module.exports = __webpack_public_path__ + "img/user-plus.8e095287.svg";